import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Notifier extends React.Component {
  state = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    containerId: "A"
  };
  componentDidMount() {
    let state = {};
    if (this.props.options !== undefined) state = { ...this.props.options };
    state.loaded = true;
    this.setState(state);
  }
  response = (type, message) => {
    if (!this.state.loaded || (this.state.loaded && this.state.toastId && toast.isActive(this.state.toastId))) {
   
      return <ToastContainer />;;
    } else {
      switch (type) {
        case "info":
          return toast.info(message, this.state);
        case "warning":
          return toast.warn(message, this.state);
        case "success":
          return toast.success(message, this.state);
        case "error":
          return toast.error(message, this.state);
        default:
          return <ToastContainer />;
      }
    }
  };
  render() {
    const { message, type } = this.props;
    if (!this.state.loaded
    ) return <ToastContainer />;
    else {
      return (
        <div style={{ color: "transparent" }}>
          <ToastContainer
            draggable
            containerId={"A"}
            position={this.state.position}
          />
          {this.response(type, message)}
        </div>
      );
    }
  }
}
export default Notifier;
